export const FM_SHOP_DETIALS = "FM_SHOP_DETIALS";
export const FM_SHOP_HEADER = "FM_SHOP_HEADER";
export const FM_SHOP_ID = "FM_SHOP_ID";

export const QUERY_SHOPSUBCATEGORIES_TITLE = "QUERY_SHOPSUBCATEGORIES_TITLE";
export const QUERY_DISTANCES_TITLE = "QUERY_DISTANCES_TITLE";
export const QUERY_REGIONS_TITLE = "QUERY_REGIONS_TITLE";
export const SHOP_PLACEHOLDER = "SHOP_PLACEHOLDER";
export const SHOP_CATEGORY_ID = "SHOP_CATEGORY_ID";
// export const QUESTIONLIST = 'QUESTIONLIST'
export const SHOP_SUB_CATEGORIES_ID = "SHOP_SUB_CATEGORIES_ID";
export const ERROR_TIPS = "ERROR_TIPS";
export const HEAD_GO_BACK_ITEM = "HEAD_GO_BACK_ITEM";
export const MC_SHOPS = "MC_SHOPS";
export const E_BEFORE_LOGIN_URL_EXHIBITION_NEW = "E_BEFORE_LOGIN_URL_EXHIBITION_NEW";

export const APP_ALERT_SHOW = "APP_ALERT_SHOW";
export const CURRENTPAGE = "CURRENTPAGE";
export const LANDINGPAGE = "LANDINGPAGE";
export const ALERT_SHOW_CLOSE = "ALERT_SHOW_CLOSE";

export const LOCATION_INFO = "LOCATION_INFO";
export const DESTINATION_SCENIC_SPOT_INFO = "DESTINATION_SCENIC_SPOT_INFO";
export const RESERVE_PEOPLE_INFO = "RESERVE_PEOPLE_INFO";
export const HOTEL_INFO = "HOTEL_INFO";
export const USER_INFO = "USER_INFO";
export const TABBAR_INDEX = "TABBAR_INDEX";
export const COMMODITY_DATES = "COMMODITY_DATES";
export const ORDER_OPTION = "ORDER_OPTION";
export const IS_CALENDAR_SHOW = "IS_CALENDAR_SHOW";
export const BOOKING_COMMODITY_ID = "BOOKING_COMMODITY_ID";

// 添加以下常量到文件末尾
export const SET_IS_BOC_APP = 'SET_IS_BOC_APP'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js